import Vue from 'vue';
import Vuex from 'vuex';
import companyStore from './modules/polls';
import answersStore from './modules/answers';
import conditionsStore from './modules/conditions';
import sessionStore from './modules/session';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    polls: companyStore,
    answers: answersStore,
    conditions: conditionsStore,
    session: sessionStore
  }
});
